import AddEditEquipment from './AddEditEquipment'
import ANTDButton from '../../../shared/antd/ANTDButton'
import ANTDModal from '../../../shared/antd/ANTDModal'
import ANTDTable from '../../../shared/antd/ANTDTable'
import equipmentTable from '../container/equipmentTable.container'

const EquipmentTable = ({
  data,
  showAdd,
  buildingId,
  selectedEquipment,
  handleSelectChange,
  onAddSuccess,
  handleTableChange,
}) => {
  const { t, columns, formModel, editData, onFormModelToggle } = equipmentTable(
    {
      handleSelectChange,
      selectedEquipment,
    },
  )
  const PAGE_SIZE = 10

  const { list, loader, lastPage, pageNo } = data || {}

  return (
    <>
      {showAdd && (
        <div className="d-flex flex-end mb-10">
          <ANTDButton
            className="btn"
            type="primary"
            onClick={onFormModelToggle}
          >
            {`${t('btn_Add')} +`}
          </ANTDButton>
        </div>
      )}
      <ANTDTable
        columns={columns}
        loading={loader}
        dataSource={list?.map(val => ({ ...val, key: val?.equipmentId }))}
        pagination={{
          pageSize: PAGE_SIZE,
          responsive: true,
          hideOnSinglePage: true,
          lastFetched: pageNo,
          current: pageNo,
          total: lastPage * PAGE_SIZE,
        }}
        scroll={{
          x: '100%',
        }}
        onChange={handleTableChange}
      />
      {formModel && (
        <ANTDModal
          title={t('job_Equipment')}
          centered
          open={formModel}
          onCancel={onFormModelToggle}
          footer={false}
          width={1100}
        >
          <AddEditEquipment
            editData={editData}
            onAddSuccess={data => {
              onFormModelToggle()
              onAddSuccess && onAddSuccess(data, !!editData)
            }}
            buildingId={buildingId}
          />
        </ANTDModal>
      )}
    </>
  )
}

export default EquipmentTable
